module.exports = {
  CloseProject: 'Закрытие проекта',
  RebuildProject: 'Перезапуск проекта',
  ProjectNo: 'Номер проекта',
  CustomerName: 'Название клиента',
  ProjectStatus: 'Статус проекта',
  ProjectName: 'Название проекта',
  ProjectCycle: 'Срок проекта',
  ProjectManager: 'Менеджер проекта',
  ProjectDepartment: 'Отдел проекта',
  ProjectOffice: 'Компания проекта',
  ExpectIncome: 'Планируемый доход',
  ExpectCost: 'Планируемые затраты',
  ExpectExpense: 'Планируемые расходы',
  RealIncome: 'Фактический доход',
  RealCost: 'Фактические затраты',
  RealExpense: 'Фактические расходы',
  SettleCurrency: 'Валюта расчёта',
  Remarks: 'Описание проекта',
  ExpectTotalCost: 'Планируемые общие расходы',
  RealTotalCost: 'Фактические общие расходы',
  ExpectProfitTate: 'Планируемая рентабельность',
  RealProfitTate: 'Фактическая рентабельность',
  ReceiveStatus: 'Статус платежа',
  PayStatus: 'Статус оплаты',
  StartDate: 'Дата начала',
  EndtDate: 'Дата окончания'
}
